import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC-nnSewpDyUGMT3aSzM0Xisoa3f0H8wls",
  authDomain: "myturbosme.firebaseapp.com",
  projectId: "myturbosme",
  storageBucket: "myturbosme.appspot.com",
  messagingSenderId: "953188972948",
  appId: "1:953188972948:web:7bf120da2f31cf045eb781",
  measurementId: "G-J60WV3VHH8"
};
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
